import { render, staticRenderFns } from "./PendingApproval.vue?vue&type=template&id=8f4e5228&scoped=true&"
import script from "./PendingApproval.vue?vue&type=script&lang=js&"
export * from "./PendingApproval.vue?vue&type=script&lang=js&"
import style0 from "./PendingApproval.vue?vue&type=style&index=0&id=8f4e5228&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f4e5228",
  null
  
)

export default component.exports